module.exports = __webpack_public_path__ + "static/img/img-cup.541387c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-cup.png
// module id = gms6
// module chunks = 1